import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --ivory: hsl(200deg 7% 91%);
    --light-accent: hsl(165deg 23% 31%);
    --main-brand: hsl(191deg 79% 15%);
    --dark-accent: hsl(187deg 55% 10%);
    --dark-shades: hsl(187deg 10% 18%);
    --taupe: hsl(0deg 17% 61%);
    --black: hsl(0deg 0% 18%);
    --shadow: hsl(0deg 0% 40%);
    --light-grey: hsl(187deg 10% 60%);
    box-sizing: border-box;
  }
  html {
    font-size: 1.25rem;
  }
  body {
    font-size: 1.25rem;
    color: var(--black);
    background-color: var(--ivory);
  }
  a {
    text-decoration: none;
    color: var(--black);
  }
  link {
    color: var(--black);
  }
  GatsbyImage {
    border-radius: 8px;
  }
`;

export default GlobalStyles;
